import { render, staticRenderFns } from "./KlayFileDD.vue?vue&type=template&id=7e2f207d&scoped=true"
import script from "./KlayFileDD.vue?vue&type=script&lang=js"
export * from "./KlayFileDD.vue?vue&type=script&lang=js"
import style0 from "./KlayFileDD.vue?vue&type=style&index=0&id=7e2f207d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2f207d",
  null
  
)

export default component.exports